// extracted by mini-css-extract-plugin
export var arrows = "_37-6";
export var decrementer = "_37-a";
export var disabled = "_37-4";
export var error = "_37-1";
export var hiddenText = "_37-b";
export var incrementer = "_37-9";
export var input = "_37-8";
export var inputWrapper = "_37-0";
export var leadingIcon = "_37-c";
export var readonly = "_37-3";
export var regular = "_37-7";
export var small = "_37-5";
export var warning = "_37-2";